import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { ProvinciasDef } from "./ProvinciasDef";

export const ProvinciasIcon = IconBuildingCommunity;
export const ProvinciasHelpText = "* Aquí tendra la lista de las provincias del pais seleccionado.";

export class Provincias extends Entity<ProvinciasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ProvinciasDef(), parentKeys);
        this.Form = import('./ProvinciasForm').then((module) => module.ProvinciasForm);
        this.Title = "Provincias";
        this.Icon = ProvinciasIcon;
        this.HelpText = ProvinciasHelpText;
    }
}